import { mapThemeColors } from '@/helpers/themeColors'
import { brandTheme } from '@/plugins/vuetify/themes'
import { useClientStore, useThemeStore } from '@/stores/system'
import { onBeforeMount, watch } from 'vue'
import { useTheme } from 'vuetify'

export const useAppTheme = () => {
	const theme = useTheme()
	const themeStore = useThemeStore()
	const clientStore = useClientStore()

	// Auch auf isHpDomain lauschen: die Domain steht ggf. erst nach dem Theme fest,
	// dann muss die Markenpalette fuer die leeren Felder nachgezogen werden.
	watch(
		[() => themeStore.theme, () => clientStore.isHpDomain],
		([value, isHpDomain]) => {
			if (value) {
				theme.themes.value.client.colors = {
					...theme.themes.value.client.colors,
					...mapThemeColors(value, brandTheme(isHpDomain)),
				}
			}
		},
		{ immediate: true }
	)

	onBeforeMount(() => {
		if (themeStore.name) {
			theme.change(themeStore.name)
		}
	})

	function changeTheme(values: string[]) {
		const [value] = values
		if (!value) return

		themeStore.name = value
		theme.change(value)
	}

	return {
		changeTheme,
	}
}
